import { addSectionBrand } from "../../../services/brandService";
import { errorAlert } from "../../common/Swal";
import { BAR_MAKING_RATES, COIN_KARAT_LOSS, TOLA } from "./Init";

// PC
export function recalc(tx) {
  const qty = n(tx.qty);
  const w = n(tx.weight);
  const d = n(tx.diff);
  const amount = (w / TOLA) * qty * d;
  return {
    ...tx,
    totalAmount: w ? f2(amount).toString() : "",
    totalWeight: qty && w ? f3(qty * w).toString() : "",
  };
}

// Lab
export function recalcLab(tx) {
  const w = n(tx.weight);
  const rep = n(tx.report);
  const d = n(tx.diff);
  const tpw = n(tx.testingPw);
  const toa = n(tx.testingOa);
  const qty = n(tx.testingOaQty) || 1;

  const pure = w > 0 ? ((96 - rep) / 96) * w : 0;
  const diffAmt = w > 0 ? (w / TOLA) * d : 0;
  const testPW = w * tpw;
  const testOA = toa * qty;

  return {
    ...tx,
    pureWeight: pure ? f3(pure).toString() : "",
    diffAmount: diffAmt ? f2(diffAmt).toString() : "",
    totalAmount: f2(diffAmt + testPW + testOA).toString(),
  };
}

// Bar
export const recalcBar = (next, isGiven) => {
  const w = n(next.weight);
  const qty = n(next.qty) || 1;
  const disc = n(next.discount);
  const d = n(next.diff);

  // auto-fill making from table when field is empty and not manually set by user
  const key = w ? w.toFixed(3) : "";

  // Check if making is empty and needs to be auto-filled from the rate table
  // if (key && BAR_MAKING_RATES[key] && !next._makingModified) {
  //   console.log(
  //     `Auto-filling making for weight ${key} g: ${BAR_MAKING_RATES[key]} per bar`,
  //   );
  //   next.making = String(BAR_MAKING_RATES[key]);
  // }

  const making = n(next.making);
  const totalW = w * qty;
  const makingT = making * qty;
  const adjDiff = w > 0 ? (w / TOLA) * d : 0;

  next.totalWeight = totalW ? f3(totalW) : "";
  next.makingTotal = makingT ? f2(makingT) : "";

  let total;
  if (isGiven) {
    // given BAR: subtract making, subtract diff — result kept positive
    total = Math.abs(-makingT - disc - adjDiff);
  } else {
    // receive BAR: add making, add diff
    total = makingT - disc + adjDiff;
  }
  next.totalAmount = total ? f2(total) : "";

  // sync rate weight = totalWeight
  // if (totalW) next.rate = { ...next.rate, weight: f3(totalW) };
  return next;
};

// Coin
export const recalcCoin = (next, isGiven = false) => {
  const w = n(next.weight);
  const qty = n(next.qty) || 1;
  const making = n(next.making);
  const d = n(next.diff);
  const loss = COIN_KARAT_LOSS[next.karat] ?? 0;

  const totalW = w * qty;
  const pureW = totalW > 0 && loss > 0 ? ((96 - loss) / 96) * totalW : 0;
  const adjDiff = w > 0 ? (w / TOLA) * d : 0;
  const makingT = making * qty;

  next.totalWeight = totalW ? f3(totalW) : "";
  next.pureWeight = pureW ? f3(pureW) : "";
  next.totalAmount = isGiven ? f2(makingT - adjDiff) : f2(makingT + adjDiff);

  if (pureW) next.rate = { ...next.rate, weight: f3(pureW) };
  return next;
};

export const recalcGinni = (next) => {
  const w = n(next.weight);
  const rc = n(next.refineCharges);
  const rp = n(next.report);

  const pure = w > 0 ? ((96 - rp) / 96) * w : 0;
  next.pureWeight = pure ? f3(pure) : "";
  next.totalWeight = w ? f3(w) : "";

  let ra = n(next.refineAmount);
  if (w > 0 && w <= TOLA) {
    if (!next.isRefineAmountManual) {
      ra = 350;
      next.refineAmount = "350.00";
    }
  } else if (w > TOLA) {
    next.refineAmount = "";
    ra = 0;
  }

  next.totalAmount = w > TOLA ? f2(rc * w) : f2(ra);
  if (pure) next.rate = { ...next.rate, weight: f3(pure) };
  return next;
};
export const recalcSilver = (next) => {
  const bw = n(next.barWeight);
  const rw = n(next.rawal);
  const qty = n(next.qty) || (bw > 0 ? 1 : 0);
  const m = n(next.making);
  next.totalWeight = qty ? f3((bw + rw) * qty) : "";
  next.totalAmount = qty ? f2(m * qty) : "";
  return next;
};

export const addBrand = async (
  setLoading,
  state,
  setState,
  refreshBrands,
  section,
) => {
  //Adding new brands into the db
  if (!state.newBrandInput.trim()) {
    return alert("Brand name cannot be empty.");
  }
  try {
    setLoading(true);
    const data = await addSectionBrand(section, state.newBrandInput);
    if (data.success) {
      await refreshBrands();
      setState((p) => ({
        ...p,
        brand: name,
        showNewBrand: false,
        newBrandInput: "",
      }));
      console.log("Brand added successfully:", data.brand);
    } else {
    }
  } catch (err) {
    console.error("Error adding brand:", err);
    const errorResponseMessage =
      err.response?.data?.message || "Failed to add brand. Please try again.";
    errorAlert(errorResponseMessage);
  } finally {
    setLoading(false);
  }
};

const n = (v) => parseFloat(v) || 0;
const f2 = (v) => (isNaN(+v) ? "" : (+v).toFixed(2));
const f3 = (v) => (isNaN(+v) ? "" : (+v).toFixed(3));

// export function calcROW(prev, key, val, sign) {
//   const next = { ...prev, [key]: val };

//   if (key === "weight" || key === "rate") {
//     const w = n(key === "weight" ? val : next.weight);
//     const r = n(key === "rate" ? val : next.rate);
//     next.amount = w > 0 && r > 0 ? f2((w / TOLA) * r) : "";
//     next.totalAmount = rowTotal(next, sign);
//   }

//   if (key === "diff") {
//     next.totalAmount = rowTotal(next, sign);
//   }

//   if (key === "amount") {
//     const a = n(val);
//     const r = n(next.rate);
//     if (a > 0 && r > 0) next.weight = f3((a * TOLA) / r);
//     next.totalAmount = rowTotal(next, sign);
//   }

//   return next;
// }

// export function rowTotal(s, sign) {
//   const a = n(s.amount);
//   const w = n(s.weight);
//   const d = n(s.diff);
//   return f2(a + sign * ((w / TOLA) * d));
// }

export function calcGSRW(prev, key, val) {
  const next = { ...prev, [key]: val };

  if (key === "weight" || key === "rate") {
    const w = n(key === "weight" ? val : next.weight);
    const r = n(key === "rate" ? val : next.rate);
    next.amount = w > 0 && r > 0 ? f2((w / TOLA) * r) : "";
    next.totalAmount = gsrwTotal(next);
  }

  if (key === "diff") {
    next.totalAmount = gsrwTotal(next);
  }

  if (key === "amount") {
    const a = n(val);
    const r = n(next.rate);
    if (a > 0 && r > 0) next.weight = f3((a * TOLA) / r);
    next.totalAmount = gsrwTotal(next);
  }

  return next;
}

export function gsrwTotal(s) {
  const w = n(s.weight);
  const r = n(s.rate);
  const d = n(s.diff);
  // recompute base from weight×rate if both set (matches JS behaviour)
  const base = w > 0 && r > 0 ? (w / TOLA) * r : n(s.amount);
  return f2(base + (w / TOLA) * d);
}
